"use strict";
// WIP Types
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRollingProgrammeToItemEdgeType = exports.isRollingPatternDisabledReport = exports.isRollingPatternReport = exports.isRollingPatternRequest = exports.isRollingPatternDisabledConfig = exports.isRollingPatternConfig = exports.displayRollingPatternStartStopDate = exports.rollingPatternConfigToStartStopDates = void 0;
const tslib_1 = require("tslib");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const lambda_1 = require("../../../util/lambda");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
const rollingPatternConfigToStartStopDates = (rpc) => {
    const { duration, delay, startTimeUtcSeconds } = rpc;
    const startPatternUtc = new Date(startTimeUtcSeconds * iotv_v3_types_1.Milliseconds.SECOND);
    const startOperationUtc = new Date(startPatternUtc);
    startOperationUtc.setMinutes(startOperationUtc.getUTCMinutes() + delay);
    const stopOperationUtc = new Date(startOperationUtc);
    stopOperationUtc.setMinutes(stopOperationUtc.getUTCMinutes() + duration);
    return {
        startPatternUtc,
        startOperationUtc,
        stopOperationUtc,
    };
};
exports.rollingPatternConfigToStartStopDates = rollingPatternConfigToStartStopDates;
const displayRollingPatternStartStopDate = (rpc) => {
    const options = { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' };
    const { startPatternUtc, startOperationUtc, stopOperationUtc } = (0, exports.rollingPatternConfigToStartStopDates)(rpc);
    return {
        startPattern: startPatternUtc.toLocaleString(config_1.default.locale, options),
        startOperation: startOperationUtc.toLocaleString(config_1.default.locale, options),
        stopOperation: stopOperationUtc.toLocaleString(config_1.default.locale, options),
    };
};
exports.displayRollingPatternStartStopDate = displayRollingPatternStartStopDate;
const isRollingPatternConfig = (x) => {
    const c = x;
    return !!c && (0, iotv_v3_types_1.isNonNaNNumber)(c.delay) && (0, iotv_v3_types_1.isNonNaNNumber)(c.duration) && (0, iotv_v3_types_1.isNonNaNNumber)(c.startTimeUtcSeconds);
};
exports.isRollingPatternConfig = isRollingPatternConfig;
/** a rolling pattern mode REQUEST where enabled doesn't exist because the fw doesn't support it, and either the delay or duration is zero as per fw behavior */
const isRollingPatternDisabledConfig = (x) => {
    return (0, exports.isRollingPatternConfig)(x) && (x.delay === 0 || x.duration === 0);
};
exports.isRollingPatternDisabledConfig = isRollingPatternDisabledConfig;
const isRollingPatternRequest = (x) => !!x && !x.enabled && (0, exports.isRollingPatternConfig)(x);
exports.isRollingPatternRequest = isRollingPatternRequest;
/** a rolling pattern REPORT which include enabled flag  */
const isRollingPatternReport = (x) => !!x && (0, iotv_v3_types_1.isNonNaNNumber)(x.enabled) && (0, exports.isRollingPatternConfig)(x);
exports.isRollingPatternReport = isRollingPatternReport;
/** a rolling pattern DISABLED REPORT  which include enabled flag  set to zero as per fw behavior */
const isRollingPatternDisabledReport = (x) => !!x && (0, iotv_v3_types_1.isNonNaNNumber)(x.enabled) && x.enabled === 0 && (0, exports.isRollingPatternConfig)(x);
exports.isRollingPatternDisabledReport = isRollingPatternDisabledReport;
const isRollingProgrammeToItemEdgeType = (x) => {
    const c = x;
    const passes = !!c && (0, iotv_v3_types_1.isEdge)(c) && !!c.edgeAttributes && (0, iotv_v3_types_1.isNonNaNNumber)(c.edgeAttributes.windowIdx);
    debug && console.log(`INFO: isRollingProgrammeToItemEdgeType passes ${passes}`, x);
    return passes;
};
exports.isRollingProgrammeToItemEdgeType = isRollingProgrammeToItemEdgeType;
